var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8297 44.3428C61.3289 44.3428 60.1203 45.5514 60.1203 47.0521V60.1209H5.87969V47.0521C5.87969 45.5514 4.67109 44.3428 3.17031 44.3428C1.66953 44.3428 0.460938 45.5514 0.460938 47.0521V62.8303C0.460938 64.3311 1.66953 65.5396 3.17031 65.5396H62.8297C64.3305 65.5396 65.5391 64.3311 65.5391 62.8303V47.0521C65.5391 45.5514 64.3305 44.3428 62.8297 44.3428Z",
    fill: "#304059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0065 1.73829C32.5339 0.197662 34.4065 1.04766 34.9776 1.73829L50.5566 18.4992C51.5792 19.6016 51.5128 21.3148 50.4105 22.3375C49.3081 23.3602 47.5948 23.2938 46.5855 22.1914L35.7081 10.4906V45.7125C35.7081 47.2133 34.4995 48.4219 32.9987 48.4219C31.498 48.4219 30.2894 47.2133 30.2894 45.7125V10.4774L19.412 22.1781C18.3894 23.2805 16.6761 23.3336 15.5737 22.3242C14.4714 21.3016 14.4183 19.5883 15.4276 18.4859L31.0065 1.73829Z",
    fill: "#304059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlue);
export default __webpack_public_path__ + "static/media/uploadBlue.71ce0d779fddb265f03056f582be120a.svg";
export { ForwardRef as ReactComponent };